import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPieData, IPieParam, PieDataReducer } from 'types/mainPage';

const initialState: PieDataReducer = {
  params: [],
  currentParam: '',
  currentPieData: [],
};

export const pieDataSlice = createSlice({
  initialState,
  name: 'pieData',
  reducers: {
    setAllParams(state, action: PayloadAction<IPieParam[]>) {
      state.params = action.payload;
    },
    setCurrentParam(state, action: PayloadAction<string>) {
      state.currentParam = action.payload;
    },
    setCurrentPieData(state, action: PayloadAction<IPieData[]>) {
      state.currentPieData = action.payload;
    },
    resetPieData() {
      return initialState;
    },
  },
});

export default pieDataSlice.reducer;
